<template></template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        timerSlider: {
          name: "timerSlider",
          min: "1000",
          max: "10000",
          labelDesc: "timer-slider",
          callback: function() {
            vm.resources.timerSlider.defaultValue = this.value;
            vm.element.internal_config.timerSlider = this.value;
          }
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function () {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';

            vm.element.rebuild(vm.element.internal_config);
          },
        },
        arrowOptions: {
          name: "arrowOptions",
          defaultValue: false,
          labelDesc: "arrow-resource_components-slide",
          callback: function() {
            vm.resources.arrowOptions.defaultValue = this.value;
            vm.element.internal_config.arrowOptions = this.value;
          }
        },
        arrowBackground: {
          name: "arrowBackground",
          defaultValue: '#d1d1d1',
          labelDesc: "arrow-background-slider",
          callback: function () {
            vm.resources.arrowBackground.defaultValue = this.colorValue;
            vm.element.internal_config.arrowBackground = this.colorValue;
          }
        },
        arrowColor: {
          name: "arrowColor",
          defaultValue: '#d1d1d1',
          labelDesc: "arrow-color-slider",
          callback: function () {
            vm.resources.arrowColor.defaultValue = this.colorValue;
            vm.element.internal_config.arrowColor = this.colorValue;
          }
        },
        arrowSize: {
          name: "arrowSize",
          defaultValue: 25,
          labelDesc: "arrow-size-slider",
          callback: function () {

            vm.resources.arrowOptions.arrowSize = parseInt(this.value);
            vm.element.internal_config.arrowSize = parseInt(this.value) + 'px';
          }
        },
        autoPlaySlider: {
          name: "autoPlaySlider",
          defaultValue: true,
          labelDesc: "auto-play-slider",
          callback: function() {
            vm.resources.autoPlaySlider.defaultValue = this.value;
            vm.element.internal_config.autoPlaySlider = this.value;
          }
        },
        titleTextContent: {
            name: 'blogTitleStyle',
            defaultFamily: '',
            defaultSize: '',
            defaultColor: '',
            defaultSizeMobile: '',
            shitOptions: true,
            showSizeMobile: true,
            defaultStroke: '',
            defaultAlign: '',
            labelDesc: 'blogTitleStyle',
            callback: function () {

              vm.resources.titleTextContent.defaultFamily = this.family;
              vm.element.internal_config.titleTextContent.family = this.family;

              vm.resources.titleTextContent.defaultSize = this.size + 'px';
              vm.element.internal_config.titleTextContent.size = this.size + 'px';

              vm.resources.titleTextContent.defaultSizeMobile = this.sizeMobile + 'px';
              vm.element.internal_config.titleTextContent.sizeMobile = this.sizeMobile + 'px';

              vm.resources.titleTextContent.defaultColor = this.color;
              vm.element.internal_config.titleTextContent.color = this.color;

              vm.resources.titleTextContent.defaultAlign = this.align;
              vm.element.internal_config.titleTextContent.align = this.align;

              vm.resources.titleTextContent.defaultWeight = this.weight;
              vm.element.internal_config.titleTextContent.weight = this.weight;

              vm.resources.titleTextContent.defaultStyle = this.style;
              vm.element.internal_config.titleTextContent.style = this.style;

              vm.resources.titleTextContent.defaultStroke = this.stroke;
              vm.element.internal_config.titleTextContent.stroke = this.stroke;

            },
        },
        subTextStyle: {
            name: 'subTextContent',
            defaultFamily: '',
            defaultSize: '',
            defaultColor: '',
            defaultSizeMobile: '',
            shitOptions: true,
            showSizeMobile: true,
            defaultStroke: '',
            defaultAlign: '',
            labelDesc: 'subTextContent',
            callback: function () {

              vm.resources.subTextStyle.defaultFamily = this.family;
              vm.element.internal_config.subTextStyle.family = this.family;

              vm.resources.subTextStyle.defaultSize = this.size + 'px';
              vm.element.internal_config.subTextStyle.size = this.size + 'px';

              vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
              vm.element.internal_config.subTextStyle.sizeMobile = this.sizeMobile + 'px';

              vm.resources.subTextStyle.defaultColor = this.color;
              vm.element.internal_config.subTextStyle.color = this.color;

              vm.resources.subTextStyle.defaultAlign = this.align;
              vm.element.internal_config.subTextStyle.align = this.align;

              vm.resources.subTextStyle.defaultWeight = this.weight;
              vm.element.internal_config.subTextStyle.weight = this.weight;

              vm.resources.subTextStyle.defaultStyle = this.style;
              vm.element.internal_config.subTextStyle.style = this.style;

              vm.resources.subTextStyle.defaultStroke = this.stroke;
              vm.element.internal_config.subTextStyle.stroke = this.stroke;

            },
        },
        blogInfoContentHeight: {
          name: "blogInfoContentHeight",
          defaultValue: "80",
          min: "20",
          max: "200",
          labelDesc: "height",
          callback: function() {
            vm.resources.blogInfoContentHeight.defaultValue = this.value;
            vm.element.internal_config.infoContentHeight = this.value + "px";
          }
        },
        blogInfoContentColor: {
          name: "blogInfoContentColor",
          defaultValue: '#d1d1d1',
          labelDesc: "bg-color",
          callback: function() {
            vm.resources.blogInfoContentColor.defaultValue = this.colorValue;
            vm.element.internal_config.infoContentColor = this.colorValue;
          }
        },
        zIndex: {
          name: "zIndex",
          defaultValue: "",
          labelDesc: "zIndex",
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        width: {
          name: "width",
          defaultValue: "150",
          min: "1",
          max: "1000",
          labelDesc: "width",
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + "px";
          }
        },
        height: {
          name: "height",
          defaultValue: "300",
          min: "1",
          max: "1000",
          labelDesc: "height",
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.height = this.value + "px";
          }
        },
        minHeight: {
          name: "minHeight",
          defaultValue: "50",
          min: "0",
          max: "2000",
          labelDesc: "minHeight",
          callback: function() {
            vm.resources.minHeight.defaultValue = this.value;
            vm.element.internal_config.minHeight = this.value + "px";

            vm.element.rebuild(vm.element.internal_config);
          }
        },
        border: {
          name: "border",
          defaultValue: "1px solid black",
          min: "0",
          max: "50",
          labelDesc: "border",
          callback: function() {
            let value = this.value + "px " + this.value2 + " " + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.border = value;
          }
        },
        opacity: {
          name: "opacity",
          defaultValue: "100",
          min: "0",
          max: "100",
          labelDesc: "opacity",
          callback: function() {
            vm.resources.opacity.defaultValue = this.value;
            vm.element.internal_config.opacity = this.value / 100;
          }
        },
        boxShadow: {
          name: "boxShadow",
          defaultValue: "0 0 0 0 black initial",
          min: "0",
          max: "50",
          labelDesc: "boxShadow",
          inset: false,
          callback: function() {
            let value =
              this.h +
              "px " +
              this.v +
              "px " +
              this.b +
              "px " +
              this.s +
              "px " +
              this.colorValue +
              " " +
              (this.i === true ? "inset" : "");

            vm.resources.boxShadow.defaultValue = value;
            vm.element.internal_config.boxShadow = value;
          }
        },
        borderRadius: {
          name: "borderRadius",
          defaultValue: "0 0 0 0",
          min: "0",
          max: "360",
          labelDesc: "borderRadius",
          callback: function() {
            let value =
              this.v1 +
              "px " +
              this.v2 +
              "px " +
              this.v3 +
              "px " +
              this.v4 +
              "px";

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.borderRadius = value;
          }
        },
        blogInfoContentPadding: {
            name: 'blogInfoContentPadding',
            defaultLeft: '15',
            defaultTop: '15',
            defaultRight: '15',
            defaultBottom: '15',
            min: '0',
            max: '100',
            labelDesc: 'paddingContainer',
            callback: function () {
              vm.resources.blogInfoContentPadding.defaultLeft = this.l;
              vm.element.internal_config.infoContentPadding.paddingLeft = this.l + 'px';

              vm.resources.blogInfoContentPadding.defaultTop = this.t;
              vm.element.internal_config.infoContentPadding.paddingTop = this.t + 'px';

              vm.resources.blogInfoContentPadding.defaultRight = this.r;
              vm.element.internal_config.infoContentPadding.paddingRight = this.r + 'px';

              vm.resources.blogInfoContentPadding.defaultBottom = this.b;
              vm.element.internal_config.infoContentPadding.paddingBottom = this.b + 'px';


            },
          },
      }
    };
  },
  methods: {
    setValuesData(data) {
      this.element = data;

      this.resources.titleTextContent.defaultFamily = data.internal_config.titleTextContent.family;
        this.resources.titleTextContent.defaultSize = data.internal_config.titleTextContent.size;
        this.resources.titleTextContent.defaultSizeMobile = data.internal_config.titleTextContent.sizeMobile;
        this.resources.titleTextContent.defaultColor = data.internal_config.titleTextContent.color;
        this.resources.titleTextContent.defaultAlign = data.internal_config.titleTextContent.align;
        this.resources.titleTextContent.defaultWeight = data.internal_config.titleTextContent.weight;
        this.resources.titleTextContent.defaultStyle = data.internal_config.titleTextContent.style;
        this.resources.titleTextContent.defaultStroke = data.internal_config.titleTextContent.stroke;


      this.resources.subTextStyle.defaultFamily = data.internal_config.subTextStyle.family;
      this.resources.subTextStyle.defaultSize = data.internal_config.subTextStyle.size;
      this.resources.subTextStyle.defaultSizeMobile = data.internal_config.subTextStyle.sizeMobile;
      this.resources.subTextStyle.defaultColor = data.internal_config.subTextStyle.color;
      this.resources.subTextStyle.defaultAlign = data.internal_config.subTextStyle.align;
      this.resources.subTextStyle.defaultWeight = data.internal_config.subTextStyle.weight;
      this.resources.subTextStyle.defaultStyle = data.internal_config.subTextStyle.style;
      this.resources.subTextStyle.defaultStroke = data.internal_config.subTextStyle.stroke;


      this.resources.blogInfoContentColor.defaultValue = data.internal_config.infoContentColor
      this.resources.blogInfoContentHeight.defaultValue = data.internal_config.infoContentHeight

      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      this.resources.timerSlider.defaultValue = parseInt(
        data.internal_config.timerSlider
      );
      this.resources.arrowOptions.defaultValue =
        data.internal_config.arrowOptions;

      this.resources.arrowSize.defaultValue = parseInt(data.internal_config.arrowSize);
      this.resources.arrowBackground.defaultValue = data.internal_config.arrowBackground;
      this.resources.arrowColor.defaultValue = data.internal_config.arrowColor;

      this.resources.autoPlaySlider.defaultValue =
        data.internal_config.autoPlaySlider;

      this.resources.width.defaultValue = parseInt(data.internal_config.width);
      this.resources.height.defaultValue = parseInt(
        data.internal_config.height
      );
      this.resources.minHeight.defaultValue = parseInt(
        data.internal_config.minHeight
      );

      this.resources.opacity.defaultValue = data.internal_config.opacity * 100;

      this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;
      this.resources.borderRadius.defaultValue =
        data.internal_config.borderRadius;
      this.resources.border.defaultValue = data.internal_config.border;


        this.resources.blogInfoContentPadding.defaultLeft = parseInt(data.internal_config.infoContentPadding.paddingLeft);
        this.resources.blogInfoContentPadding.defaultTop = parseInt(data.internal_config.infoContentPadding.paddingTop);
        this.resources.blogInfoContentPadding.defaultRight = parseInt(data.internal_config.infoContentPadding.paddingRight);
        this.resources.blogInfoContentPadding.defaultBottom = parseInt(data.internal_config.infoContentPadding.paddingBottom);
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/NewsSlider/Resources.vue